import { render, staticRenderFns } from "./ExaminationTopicCommentRow.vue?vue&type=template&id=4be4478d&scoped=true&"
import script from "./ExaminationTopicCommentRow.vue?vue&type=script&lang=js&"
export * from "./ExaminationTopicCommentRow.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationTopicCommentRow.vue?vue&type=style&index=0&id=4be4478d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be4478d",
  null
  
)

export default component.exports